import React from 'react'
import styles from "./LoadMore.module.css"

function LoadMore({ onClick, isLoading = false }: { onClick: () => void, isLoading?: boolean }) {
  return (
    <>
      <div className={styles.bgclr}>
        <button
          type="button"
          className={styles.SeeMoreBtn}
          onClick={onClick}
          disabled={isLoading}
          aria-busy={isLoading}
        >
          {isLoading ? 'Loading…' : 'Load More'}
        </button>
        {/* Keep spinner markup if it's used for layout, but hide it when using button text for loading */}
        <div className={styles.spinner} style={{ display: 'none' }}></div>
      </div>
    </>
  )
}

export default LoadMore